wp.customize('blogname', (value) => {
    document.querySelectorAll('.brand').forEach((name) => {
        value.bind(to => name.textContent = to);
    });
});
